/*
 * Dolcenida : taies offertes avec chaque couette.
 * Pour chaque EasySleep® Duvet du panier, ajoute 1 lot de « SoftCloud® Pillowcases (Set of 2) – Free gift »
 * (produit non répertorié à 0, une variante par couleur) de la même couleur.
 * Pas de remise Shopify : une remise sur les taies empêchait la remise Kaching des packs.
 * Les lots cadeaux sans couette correspondante sont retirés.
 */
(function () {
  var DUVET_PRODUCT_ID = 16007629832574;
  var GIFT_PRODUCT_ID = 16128039747966;
  var GIFT_KEY = 'Gift';
  var GIFT_VALUE = '2 matching pillowcases, free with your duvet';
  var CASE_VARIANT_BY_COLOUR = {
    'Coastal Blue': 58193405837694,
    'Cream Beige': 58193405870462,
    'Sunset Orange': 58193405903230,
    'Chimney Red': 58193405935998,
    'Midnight Black': 58193405968766,
    'Moonstone Grey': 58193406001534,
    'Soft Mint Green': 58193406034302,
    'Lilac Dream': 58193406067070,
    'Cloud White': 58193406099838,
    'Cocoa Brown': 58193406132606
  };

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var syncing = false;
  var pending = false;
  var timer = null;
  var fromCartAction = false;

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  function colourOf(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (/colou?r/i.test(opts[i].name)) return opts[i].value;
    }
    return (item.variant_options || [])[0];
  }

  function isGiftLine(item) {
    return item.product_id === GIFT_PRODUCT_ID;
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Redessine le tiroir panier (il s'ouvre, comme après un ajout normal).
  // Au chargement de page, on le referme aussitôt pour ne pas surprendre le client.
  function refreshCartUi(keepOpen) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      return post('cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] })
        .then(function (data) {
          drawer.renderContents(data);
          if (!keepOpen && typeof drawer.close === 'function') drawer.close();
        });
    }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
    return Promise.resolve();
  }

  function sync() {
    if (syncing) { pending = true; return; }
    syncing = true;
    var keepOpen = fromCartAction;
    fromCartAction = false;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wanted = {};
        var giftLines = {};
        cart.items.forEach(function (item) {
          if (item.product_id === DUVET_PRODUCT_ID) {
            var c = colourOf(item);
            if (CASE_VARIANT_BY_COLOUR[c]) wanted[c] = (wanted[c] || 0) + item.quantity;
          } else if (isGiftLine(item)) {
            var colour = colourOf(item);
            (giftLines[colour] = giftLines[colour] || []).push(item);
          }
        });

        var steps = [];
        var toAdd = [];
        Object.keys(CASE_VARIANT_BY_COLOUR).forEach(function (c) {
          var lines = giftLines[c] || [];
          var target = wanted[c] || 0;
          var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
          if (have === target && lines.length <= 1) return;
          // Une seule ligne cadeau par couleur, à la bonne quantité.
          lines.forEach(function (l, i) {
            var q = i === 0 && target > 0 ? target : 0;
            if (l.quantity !== q) steps.push({ id: l.key, quantity: q });
          });
          if (!lines.length && target > 0) {
            var props = {};
            props[GIFT_KEY] = GIFT_VALUE;
            toAdd.push({ id: CASE_VARIANT_BY_COLOUR[c], quantity: target, properties: props });
          }
        });

        if (!steps.length && !toAdd.length) return false;
        var chain = Promise.resolve();
        steps.forEach(function (s) { chain = chain.then(function () { return post('cart/change.js', s); }); });
        if (toAdd.length) chain = chain.then(function () { return post('cart/add.js', { items: toAdd }); });
        return chain.then(function () { return true; });
      })
      .then(function (changed) { if (changed) return refreshCartUi(keepOpen); })
      .catch(function (e) { console.warn('[Dolcenida taies offertes]', e); })
      .then(function () {
        syncing = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  // Détecte toute modification du panier (thème, Kaching, autres apps).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var p = nativeFetch(input, init);
    if (isCartMutation(url)) p.then(function () { fromCartAction = true; schedule(); }, function () {});
    return p;
  };
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('load', function () { fromCartAction = true; schedule(); });
    return open.apply(this, arguments);
  };

  // La quantité des lots cadeaux suit les couettes : on masque +/− et la corbeille sur ces lignes.
  var giftVariantIds = Object.keys(CASE_VARIANT_BY_COLOUR).map(function (c) { return String(CASE_VARIANT_BY_COLOUR[c]); });
  function lockGiftLines() {
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(function (input) {
      if (giftVariantIds.indexOf(input.getAttribute('data-quantity-variant-id')) === -1) return;
      var wrapper = input.closest('.cart-item__quantity-wrapper') || input.closest('quantity-input');
      if (!wrapper || wrapper.getAttribute('data-gift-locked')) return;
      wrapper.setAttribute('data-gift-locked', '1');
      wrapper.style.display = 'none';
    });
  }

  function start() {
    schedule();
    lockGiftLines();
    new MutationObserver(lockGiftLines).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
